import React, { useState } from 'react';
import FormularioOportunidade from '../Formulario/FormularioOportunidade';

export default function PopupNovaOportunidade({ cliente, onClose }) {
  const [dadosOportunidade, setDadosOportunidade] = useState(null);

  return (
    <div className="popup-agendamento-overlay" onClick={onClose}>
      <div className="popup-agendamento" onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
        <button
          className="popup-fechar-btn"
          onClick={onClose}
          aria-label="Fechar"
        >
          ×
        </button>
        <div className="popup-agendamento-centro">
          <div className="popup-titulo-laranja">Nova Oportunidade para o Cliente</div>
          <FormularioOportunidade
            clienteId={cliente.id || cliente.Id}
            dadosOportunidade={{
              clienteId: cliente.id || cliente.Id,
              clienteNome: cliente.nome || cliente.Nome
            }}
            setDadosOportunidade={setDadosOportunidade}
            onClose={onClose}
          />
        </div>
      </div>
    </div>
  );
}
